import type { MatomoEventAction, MatomoEventCategory } from "@/types";

export function trackPageView(url: string, actionName = ""): void {
  if (import.meta.env.DEV) {
    /* eslint-disable no-console */
    console.log("MATOMO: Manual page view");
    console.table({ url, actionName });
    /* eslint-enable no-console */
  }

  if (!hasMatomo()) {
    return;
  }

  window._paq.push(["setCustomUrl", url]);
  window._paq.push(["trackPageView", actionName]);
}

export function updateUserType(userType: unknown) {
  if (hasMatomo()) {
    window._paq.push(["setCustomDimension", 1, userType]);
    window._paq.push(["setCustomDimension", 2, userType]);
  }
}

export function sendEvent(
  category: MatomoEventCategory,
  action: MatomoEventAction,
  label?: string
): void {
  if (import.meta.env.DEV) {
    /* eslint-disable no-console */
    console.log("MATOMO: Event");
    console.table({ category, action, label });
    /* eslint-enable no-console */
  }

  if (!hasMatomo()) {
    return;
  }

  // Value and dimensions are never used, but are kept in for clarity on where to put them if we want to use them down the line.
  const value = undefined;
  const dimensions = undefined;

  window._paq.push(["trackEvent", category, action, label, value, dimensions]);
}

function hasMatomo(): boolean {
  return Object.prototype.hasOwnProperty.call(window, "_paq");
}
